import React, { useState } from "react";
import { Tooltip } from "react-tooltip";
import { VscClose } from "react-icons/vsc";
import { TbRotateClockwise } from "react-icons/tb";
import { MdKeyboardArrowDown } from "react-icons/md";

import WhiteLogo from "@Components/WhiteLogo";
import IconButton from "@Components/IconButton";

import SupportChat from "./RenderChat";
import {
  initialTicketState,
  initialLoanTicketState,
} from "../SupportMachine/TicketStateMachine";
import styles from "./TicketsChat.module.scss";
import CloseChatDialog from "./CloseChatDialog";
import { TicketState } from "../SupportMachine/types";

export default function ChatDialog({
  open,
  state,
  setOpen,
  setState,
}: {
  open: boolean;
  state: TicketState;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setState: React.Dispatch<React.SetStateAction<TicketState>>;
}) {
  const [text, setText] = useState("");
  const [openCloseChatWarning, setOpenCloseChatWarning] = useState(false);

  const handleHideDialog = () => {
    setOpen(false);
  };

  const handleResetState = () => {
    setState(
      state.type === "deal" && state.ticketData.deal
        ? initialLoanTicketState(state.ticketData.deal)
        : initialTicketState
    );
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setOpenCloseChatWarning(true);
  };

  return (
    <>
      <CloseChatDialog
        open={openCloseChatWarning}
        setOpen={setOpenCloseChatWarning}
        handleResetState={handleResetState}
      />
      {(open || openCloseChatWarning) && <div className={styles.backdrop} />}
      {open && (
        <dialog
          id="support-dialog"
          data-testid="dialog"
          className={styles.dialogContainer}
          open={true}
        >
          <div className={styles.dialogHeader}>
            <WhiteLogo />
            <div className={styles.title}>Support</div>
            <div className={styles.dialogButtons}>
              <Tooltip
                anchorId={"reset-dialog-button"}
                place="top"
                style={{ fontSize: "10px" }}
                content="Click here to start the chat over"
              />

              <IconButton
                id="reset-dialog-button"
                style={{ padding: 0 }}
                onClick={handleResetState}
              >
                <TbRotateClockwise color="white" size={25} />
              </IconButton>

              <IconButton
                style={{ padding: 0 }}
                dataTestId="close-dialog-button"
                onClick={handleHideDialog}
              >
                <MdKeyboardArrowDown color="white" size={30} />
              </IconButton>
              <IconButton
                style={{ padding: 0 }}
                dataTestId="close-dialog-button"
                onClick={handleCloseDialog}
              >
                <VscClose color="white" size={30} />
              </IconButton>
            </div>
          </div>
          <div className={styles.dialogContent}>
            <SupportChat
              state={state}
              setState={setState}
              text={text}
              setText={setText}
            />
          </div>
        </dialog>
      )}
    </>
  );
}
